import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable max-len */

/**
The main entry point for Collections.
Referenced by numerous collection.*.liquid templates.
* */
import { gql, useQuery } from 'urql';
import ReactDOM from 'react-dom';
import './scss/templates/collection.scss';
import { retailCategoryPageView } from './utils/retail';
import Collection, { Wrap } from './apps/collection/Collection';
import CollectionLoading from './components/CollectionLoading';
import OVApp from './utils/OVContext';
import { jsx as _jsx } from "react/jsx-runtime";
var _window$OV = window.OV,
    COLLECTION = _window$OV.COLLECTION,
    COLLECTION_ID = _window$OV.COLLECTION_ID;
var paletteFilterParam = 'paletteFilter';

var Preload = function Preload() {
  var banner = _objectSpread(_objectSpread({}, COLLECTION), {}, {
    component: 'TEXT_ONLY'
  });

  var urlParams = new URLSearchParams(window.location.search);
  var paletteParam = urlParams.get(paletteFilterParam);
  var query = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query PreloadCollection($id: String!) {\n      collection: collectionShopify(shopifyId: $id) {\n        productSets {\n          id\n        }\n        properties {\n          id\n          gridDisplayEditorial\n          gridDisplaySwatches\n        }\n        shopifyId\n      }\n    }\n  "])));

  var _useQuery = useQuery({
    query: query,
    variables: {
      id: COLLECTION_ID
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching,
      error = _useQuery2$.error;

  if (fetching) {
    return /*#__PURE__*/_jsx(Wrap, {
      banner: banner,
      children: /*#__PURE__*/_jsx(CollectionLoading, {})
    });
  }

  if (error) {
    console.error(error);
    return /*#__PURE__*/_jsx(Wrap, {
      banner: banner,
      children: /*#__PURE__*/_jsx("h2", {
        children: "Something went wrong."
      })
    });
  }

  var _data$collection = data.collection,
      properties = _data$collection.properties,
      productSets = _data$collection.productSets;
  return /*#__PURE__*/_jsx(Collection, {
    banner: banner,
    displayEditorial: properties.gridDisplayEditorial,
    displaySwatches: properties.gridDisplaySwatches,
    paginate: productSets.length == 1,
    paletteParam: paletteParam,
    shopifyId: COLLECTION_ID
  });
};

var init = function init() {
  ReactDOM.render( /*#__PURE__*/_jsx(OVApp, {
    children: /*#__PURE__*/_jsx(Preload, {})
  }), document.getElementById('collection'));
};

init();
retailCategoryPageView({
  collectionTitle: window.OV.COLLECTION.title
});